function ingredientListReveal() {
  const ingredientListItem = document.querySelectorAll('.js-ingredients__item');

  // Curent active
  let activeIngredientElement = document.querySelector('.js-ingredients__item.active-ingredient'),
      activeIngredientContent = document.querySelector('.js-ingredient__content.active-ingredient');

  let isMobile = false;

  if (window.innerWidth <= 989) {
    isMobile = true;
  }
  
  ingredientListItem.forEach((ingredient) => {
    if (isMobile) {
      //ingredient.style.pointerEvents = 'none';
      ingredient.addEventListener('click', (e) => {
        // Remove current active
        if (activeIngredientElement && activeIngredientElement !== e.target) {
          activeIngredientElement.classList.remove('active-ingredient');
          activeIngredientContent.classList.remove('active-ingredient');
        }
  
        // Assign new current active
        let ingredientElement = e.target.closest('.js-ingredients__item');
        let ingredientContent = ingredientElement.querySelector('.js-ingredient__content');
  
        activeIngredientElement = ingredientElement;
        activeIngredientContent = ingredientContent;
        
        ingredientElement.classList.add('active-ingredient');
        ingredientContent.classList.add('active-ingredient');
      });
    } else {
      ingredient.addEventListener('mouseover', (e) => {
        // Remove current active
        if (activeIngredientElement && activeIngredientElement !== e.target) {
          activeIngredientElement.classList.remove('active-ingredient');
          activeIngredientContent.classList.remove('active-ingredient');
        }
  
        // Assign new current active
        let ingredientElement = e.target.closest('.js-ingredients__item');
        let ingredientContent = ingredientElement.querySelector('.js-ingredient__content');
  
        activeIngredientElement = ingredientElement;
        activeIngredientContent = ingredientContent;
        
        ingredientElement.classList.add('active-ingredient');
        ingredientContent.classList.add('active-ingredient');
      });
    }
  });
}

ingredientListReveal();